
function playSound() {
    const audio = new Audio(require(`@/assets/error.mp3`));
    audio.play();
}

export default {
    playSound
}
